import React from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import AddStudentForm from './AddStudentForm';

interface Props {
  open: boolean;
  onClose: () => void;
  schoolId: number;
  onSuccess: () => void;
}

const AddStudentDialog: React.FC<Props> = ({ open, onClose, schoolId, onSuccess }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add New Student</DialogTitle>
      <DialogContent>
        <AddStudentForm schoolId={schoolId} onSuccess={() => { onSuccess(); onClose(); }} />
      </DialogContent>
    </Dialog>
  );
};

export default AddStudentDialog; 